export default __webpack_public_path__ + "static/petsafe-logo-2d33e95a9c3df018954ebb2b1a57bc4e.svg";